import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'production/cooperation';

const cooperationMaterialService = {
  resolveOperationIdentifier: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/resolveOperationIdentifier`,
      data,
    });
  },

  createDocument: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/document`,
      data,
    });
  },
};

export default cooperationMaterialService;
